export const IS_DEV = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
export const zoomIncrement = 0.25;

export const EML_CONTENT_TYPE = 'application/message/rfc822';
export const HTML_CONTENT_TYPE = 'application/html';
export const PDF_CONTENT_TYPE = 'application/pdf';

export const PDF_PAGES_LIMIT = 40;
